module.exports = __webpack_public_path__ + "img/c03_buildingtechgiftofsequina_Normal_ua.f138b0f1.webp";